import request from "../utils/request"; // 获取书籍列表

export var books = function books(data) {
  return request({
    url: '/book/info_list',
    method: 'post',
    data: data
  });
}; // 获取分类

export var cateInfo_list = function cateInfo_list() {
  return request({
    url: '/cate/info_list',
    method: 'get'
  });
}; // 获取作者

export var authorInfo_list = function authorInfo_list() {
  return request({
    url: '/author/info_list',
    method: 'get'
  });
}; // 提交

export var updateBook = function updateBook(data) {
  return request({
    url: 'update/book',
    method: 'post',
    data: data
  });
}; // 搜索分类

export var searchCate = function searchCate(data) {
  return request({
    url: '/search/cate',
    method: 'post',
    data: data
  });
}; // 搜索作者

export var searchAuthor = function searchAuthor(data) {
  return request({
    url: '/search/author',
    method: 'post',
    data: data
  });
}; // 删除

export var deleteAudit = function deleteAudit(data) {
  return request({
    url: '/book/remove',
    method: 'post',
    data: data
  });
}; // 首页查询搜索

export var searchBook = function searchBook(data) {
  return request({
    url: '/search/book',
    method: 'post',
    data: data
  });
};